<div class="projection-detail-page" *ngIf="projectionSet">
  <!-- Header bar -->
  <div class="projection-header">
    <div class="header-left">
      <span class="back-link" (click)="navigateBack()">
        <i class="material-icons" style="font-size: 18px; vertical-align: middle;">arrow_back</i>
        Back to Client
      </span>
      <div class="projection-title-row">
        <input type="text"
               class="projection-name-input"
               [(ngModel)]="projectionName"
               (blur)="onProjectionNameBlur()"
               placeholder="Projection Name" />
      </div>
    </div>
    <div class="header-right">
      <div class="header-field">
        <label>1040 Source:</label>
        <select class="header-select" [(ngModel)]="selectedOcrFileId" (change)="onOcrDocumentChange()">
          <option value="">-- Select 1040 --</option>
          <option *ngFor="let doc of ocrDocuments" [value]="doc.id">
            {{doc.year}} ({{doc.filename}})
          </option>
        </select>
      </div>
      <div class="header-field">
        <label>Projection Year:</label>
        <select class="header-select" [(ngModel)]="projectionYear" (change)="onProjectionYearChange()">
          <option *ngFor="let year of availableYears" [value]="year">{{year}}</option>
        </select>
      </div>
      <div class="header-field">
        <label>Filing Status:</label>
        <select class="header-select" [(ngModel)]="projectionSet.filingStatus" (change)="onFilingStatusChanged(projectionSet.filingStatus)">
          <option value="">-- Select --</option>
          <option value="Single">Single</option>
          <option value="Married Filing Jointly (MFJ)">Married Filing Jointly (MFJ)</option>
          <option value="Married Filing Separately (MFS)">Married Filing Separately (MFS)</option>
          <option value="Head of Household">Head of Household</option>
          <option value="Estate">Estate</option>
          <option value="Trust">Trust</option>
        </select>
      </div>
      <div class="header-field">
        <label>Home State:</label>
        <input type="text" class="header-input" [(ngModel)]="projectionSet.homeState" (blur)="onHomeStateBlur()" placeholder="e.g. California" />
      </div>
    </div>
  </div>

  <!-- Projection Grid -->
  <app-projection-grid
    [projectionSet]="projectionSet"
    [scenarios]="projectionSet.scenarios"
    [recalcTrigger]="recalcTrigger"
    (addScenarioEvent)="addScenario()"
    (deleteScenarioEvent)="deleteScenario($event)"
    (filingStatusChanged)="onFilingStatusChanged($event)">
  </app-projection-grid>
</div>
